import * as constants from './constants';

export const initialState = {
  loading: false,
  data: [],
  error: null,
};

export const itemsCategoriesReducer = (state = initialState, action) => {
  switch (action.type) {
  case constants.GET_ITEMS_CATEGORIES:
    return { ...state, loading: true };
  case constants.GET_ITEMS_CATEGORIES_SUCCESS: {
    return { ...state, loading: false, data: action.payload };
  }
  case constants.GET_ITEMS_CATEGORIES_ERROR:
    return { ...state, loading: false, error: action.payload };
  case constants.RESET_ITEMS_CATEGORIES:
    return initialState;
  default:
    return state;
  }
};
